import { PopperTooltip } from "~/common/components/Tooltip";
import { LinkButton } from "~/common/components/Link";
import CircleSpinner from "~/common/components/CircleSpinner/CircleSpinner";
import type { ReactNode } from "react";
import DownloadIcon from "@mui/icons-material/Download";

export const DownloadContentButton = (props: {
  onClick: () => void;
  label: ReactNode;
  labelHover?: ReactNode;
  isLoading: boolean;
  className?: string;
  "data-test-id"?: string;
}) => (
  <PopperTooltip hideTooltip={!props.labelHover} tooltipContent={props.labelHover} placement={"bottom-end"}>
    <LinkButton
      data-test-id={props["data-test-id"]}
      iconBefore={props.isLoading ? <CircleSpinner /> : <DownloadIcon  />}
      onClick={props.onClick}
      disabled={props.isLoading}
      className={props.className}
    >
      {props.label}
    </LinkButton>
  </PopperTooltip>
);
